import * as styles from '../Pill.scss';

/**
 * Provides Correct Classname Based Off Given Color Key
 * @function findPillClass
 * @param {string} color
 * @return {string}
 */
const findPillClass = color => {
  switch (color) {
    case 'BLUE':
      return styles.bluePill;
    case 'GREEN':
      return styles.greenPill;
    case 'RED':
      return styles.redPill;
    case 'SILVER':
      return styles.silverPill;
    case 'WHITE_GREEN':
      return styles.whiteGreenPill;
    default:
      return styles.silverPill;
  }
};

export default findPillClass;
